import { RadioCard, Tooltip } from "@blurb/codex-react";
import { Box } from "@mantine/core";
import { RpiLabelText } from "@rpi/openapi-core";
import { getDisplayName } from "./attributeValueMappings";

// Configuration for Text cards
export type TextCardProps = {
  value: string;
  displayName: string;
  disabled?: boolean;
  renderTooltip?: () => JSX.Element;
};

export const defaultGetTextCardConfig =
  (attributeKey: string): ((value: string) => TextCardProps | undefined) =>
  (value) => {
    if (!attributeKey) return undefined;

    const displayName = getDisplayName(attributeKey, String(value));

    if (!displayName) return undefined;

    return {
      value: String(value),
      displayName,
    };
  };

export const TextCard = ({ value, displayName, disabled = false, renderTooltip }: TextCardProps) => {
  const card = (
    <RadioCard value={value} disabled={disabled} data-testid={value}>
      <RpiLabelText>{displayName}</RpiLabelText>
    </RadioCard>
  );

  if (renderTooltip) {
    // A disabled RadioCard doesn't emit pointer events, so the tooltip anchors to a wrapper instead.
    return (
      <Tooltip content={renderTooltip()}>
        <Box sx={{ display: "inline-block" }}>{card}</Box>
      </Tooltip>
    );
  }

  return card;
};
